import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "text-subtitle-2 font-weight-500" }
const _hoisted_5 = {
  key: 0,
  class: "emoji-scale"
}
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "emoji-step-label" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "d-flex justify-space-between mt-0" }
const _hoisted_10 = { class: "text-caption text-grey-darken-1" }
const _hoisted_11 = { class: "text-caption text-grey-darken-1" }
const _hoisted_12 = { class: "text-h6 text-grey-darken-1" }
const _hoisted_13 = { class: "text-body-2 text-grey-darken-1 mt-2" }
const _hoisted_14 = {
  key: 3,
  class: "mx-6 mb-5"
}

import { ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useSettingsStore } from '@/api/store/settings';
import { healthTrackerService, type TrackerEntry } from "@/api/services/healthTracker";
import moment from "moment";
import RatingSlider from "@/components/custom/RatingSlider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TrackerEntryView',
  setup(__props) {

_useCssVars(_ctx => ({
  "v01c7919a": (_unref(settingsStore).settings.primaryColor)
}))

const router = useRouter();
const route = useRoute();
const settingsStore = useSettingsStore();

const isLoading = ref(true);
const isSubmitting = ref(false);
const formError = ref<string | null>(null);

const trackerId = ref<number>(0);
const entryDate = ref<string>('');
const trackerEntries = ref<any[]>([]); // Use any[] for now, or define a local type matching the API response

const isReadonly = computed(() => route.query.readonly === 'true');

const isFormValid = computed(() => {
  return trackerEntries.value.length > 0 &&
    trackerEntries.value.every(entry => {
      if (entry.value === undefined || entry.value === null) return false;
      if (entry.tracker_template?.scale_type === 'emoji') {
        const stepCount = entry.tracker_template?.scale_steps?.length ?? 0;
        return entry.value >= 1 && entry.value <= stepCount;
      }
      return (
        entry.value >= (entry.tracker_template?.scale_min ?? 0) &&
        entry.value <= (entry.tracker_template?.scale_max ?? 10)
      );
    });
});

const formattedDate = computed(() => {
  return moment(entryDate.value).format('dddd, DD MMMM YYYY');
});

const loadTrackerEntries = async () => {
  try {
    isLoading.value = true;
    trackerId.value = parseInt(route.params.id as string);
    entryDate.value = route.params.date as string;

    if (!trackerId.value || !entryDate.value) {
      formError.value = 'Invalid tracker ID or date';
      return;
    }

    try {
      // Get entries for the specific date
      const entries = await healthTrackerService.getTrackerEntriesByDate(trackerId.value, entryDate.value);
      trackerEntries.value = entries.map((entry: any) => ({
        ...entry,
        value: entry.value ?? (entry.tracker_template?.scale_min ?? 0),
        notes: entry.notes ?? '',
      }));
    } catch (entryError) {
      // If no entries exist for this date, show empty state
      console.log('No entries found for date:', entryDate.value);
      trackerEntries.value = [];
    }
  } catch (error) {
    console.error('Error loading tracker entries:', error);
    formError.value = 'Failed to load tracker entries. Please try again.';
  } finally {
    isLoading.value = false;
  }
};

const submitEntries = async () => {
  if (!isFormValid.value || !trackerId.value) return;
  isSubmitting.value = true;
  formError.value = null;

  try {
    for (const entry of trackerEntries.value) {
      const entryData = {
        entry_datetime: entry.entry_datetime,
        tracker_id: trackerId.value,
        tracker_template_id: entry.tracker_template_id,
        item_id: entry.item_id,
        value: entry.value,
        notes: entry.notes ?? '',
      };
      if (entry.id) {
        await healthTrackerService.updateEntry(trackerId.value, entry.id, entryData);
      } else {
        await healthTrackerService.createEntry(trackerId.value, entryData);
      }
    }
    router.push({ name: 'health-suite-tracker' });
  } catch (err: any) {
    formError.value = err.response?.data?.message || 'Failed to save entries. Please try again.';
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(() => {
  loadTrackerEntries();
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-5 tracker-entry-page",
    style: {"background-color":"#F5F5F5","min-height":"100vh"}
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "mx-6 pa-4 border-rounded text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary"
              }),
              _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-2" }, "Loading tracker entries...", -1))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_form, {
              onSubmit: _withModifiers(submitEntries, ["prevent"])
            }, {
              default: _withCtx(() => [
                (trackerEntries.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trackerEntries.value, (entry, index) => {
                        return (_openBlock(), _createBlock(_component_v_sheet, {
                          key: `entry-${index}`,
                          class: "mx-6 pa-4 border-rounded mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("h5", _hoisted_4, _toDisplayString(entry.tracker_template_item?.name || 'Tracker Entry'), 1)
                            ]),
                            (entry.tracker_template?.scale_type === 'emoji')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((entry.tracker_template?.scale_steps || []), (step, stepIndex) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: stepIndex,
                                      type: "button",
                                      class: _normalizeClass(["emoji-step-btn", { 'emoji-step-btn--selected': entry.value === stepIndex + 1 }]),
                                      style: _normalizeStyle(entry.value === stepIndex + 1 ? { borderColor: _unref(settingsStore).settings.primaryColor, backgroundColor: _unref(settingsStore).settings.primaryColor + '18' } : {}),
                                      disabled: isReadonly.value,
                                      onClick: ($event: any) => (entry.value = stepIndex + 1)
                                    }, [
                                      _createElementVNode("span", _hoisted_7, _toDisplayString(step), 1)
                                    ], 14, _hoisted_6))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(RatingSlider, {
                                      modelValue: entry.value,
                                      "onUpdate:modelValue": ($event: any) => ((entry.value) = $event),
                                      color: _unref(settingsStore).settings.primaryColor,
                                      min: entry.tracker_template?.scale_min || 0,
                                      max: entry.tracker_template?.scale_max || 10,
                                      disabled: isReadonly.value
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "min", "max", "disabled"])
                                  ]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(entry.tracker_template?.scale_min || 0), 1),
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(entry.tracker_template?.scale_max || 10), 1)
                                  ])
                                ], 64))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_v_sheet, {
                      key: 1,
                      class: "mx-6 pa-4 border-rounded text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "grey-lighten-1",
                          class: "mb-3"
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("fa fa-calendar-xmark", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(isReadonly.value ? 'No entries recorded for this date' : 'No tracker entries for this date'), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(isReadonly.value 
              ? `No tracker data was recorded for ${_unref(moment)(entryDate.value).format('DD MMM YYYY')}.`
              : `There are no tracker entries scheduled for ${entryDate.value}.`), 1)
                      ]),
                      _: 1
                    })),
                (formError.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 2,
                      type: "error",
                      class: "mx-6 mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formError.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (trackerEntries.value.length > 0 && !isReadonly.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        color: _unref(settingsStore).settings.primaryColor,
                        disabled: !isFormValid.value || isSubmitting.value,
                        loading: isSubmitting.value,
                        class: "w-100 py-3 text-white submit-btn",
                        size: "large",
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" Submit ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "disabled", "loading"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})